import { render, staticRenderFns } from "./ForeignOss.vue?vue&type=template&id=087e602c&scoped=true"
import script from "./ForeignOss.vue?vue&type=script&lang=js"
export * from "./ForeignOss.vue?vue&type=script&lang=js"
import style0 from "./ForeignOss.vue?vue&type=style&index=0&id=087e602c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087e602c",
  null
  
)

export default component.exports